module.exports = __webpack_public_path__ + "img/7t.1922aed2.jpg";